import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Card from "../../../UI/Card/Card";
import * as ApplicationsUtils from "../../../Utils/ApplicationsUtils";
import * as ContactUtils from "../../../Utils/ContactUtils";
import LogService from "../../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APP-EDITION-HISTORIC";

const Historic = (props) => {
    const intl = useIntl();
    const [application, setApplication] = useState(null);
    const [deployedByUserName, setDeployedByUserName] = useState("");

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect application");
        if (props.applicationId) {
            const foundApplication = ApplicationsUtils.getApplicationById(props.applicationId, props.applications);
            setApplication(foundApplication);

            if (foundApplication?.deployedByUserId) {
                const foundDeveloper = ContactUtils.getContactById(foundApplication.deployedByUserId, props.contacts);
                setDeployedByUserName(ContactUtils.getDisplayName(foundDeveloper));
            }
        }
    }, [props.applications, props.applicationId]);

    LogService.trace(LOG_TAG, "render");

    let tableValues = [
        <tr key="created">
            <td className="table-label">{intl.messages.applicationEditionHistoricCreatedOnTitle + ":"}</td>
            <td className="table-value text-right">{intl.formatDate(application?.dateOfCreation, { year: "numeric", month: "short", day: "numeric" })}</td>
        </tr>
    ];

    if (application?.dateOfDeploymentRequest) {
        tableValues.push(
            <tr key="deployRequest">
                <td className="table-label">{intl.messages.applicationEditionHistoricDeploymentRequestOnTitle + ":"}</td>
                <td className="table-value text-right">{intl.formatDate(application?.dateOfDeploymentRequest, { year: "numeric", month: "short", day: "numeric" })}</td>
            </tr>
        );
    }

    if (application?.dateOfDeployment) {
        tableValues.push(
            <tr key="deployedSince">
                <td className="table-label">{intl.messages.applicationEditionHistoricDeployedSinceTitle + ":"}</td>
                <td className="table-value text-right">{intl.formatDate(application?.dateOfDeployment, { year: "numeric", month: "short", day: "numeric" })}</td>
            </tr>
        );
    }

    if (application?.deployReason) {
        tableValues.push(
            <tr key="deployReason">
                <td className="table-label">{intl.messages.applicationEditionHistoricDeployedReasonTitle + ":"}</td>
                <td className="table-value text-right">{application.deployReason}</td>
            </tr>
        );
    }

    if (deployedByUserName) {
        tableValues.push(
            <tr key="deployedBy">
                <td className="table-label">{intl.messages.applicationEditionHistoricDeployedByTitle + ":"}</td>
                <td className="table-value text-right">{deployedByUserName}</td>
            </tr>
        );
    }

    return (
        <Card title={intl.messages.applicationEditionHistoricTitle}>
            <table className="table">
                <tbody>
                    {tableValues}
                </tbody>
            </table>
        </Card >
    );
}

Historic.propTypes = {
    applicationId: PropTypes.string,
    isSandBoxApplication: PropTypes.bool
};

Historic.defaultProps = {
    applicationId: "",
    isSandBoxApplication: false
}

const mapStateToProps = (state, props) => {
    return {
        applications: props.isSandBoxApplication ? state.sandBoxApplications.applications : state.applications.applications,
        contacts: props.isSandBoxApplication ? [...state.sandBoxContacts.contacts, state.sandBoxContacts.user] : [...state.contacts.contacts, state.contacts.user]
    };
};

export default connect(mapStateToProps)(Historic);